import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';

import { ILookupBase } from 'src/app/Models/ILookupBase';
import { ISPSDButtonControl } from 'src/app/Models/ISPSDButtonControl';


@Injectable()
export class SinglePageServiceDocumentationService extends BaseService {
  _baseUrl: string = "";
  _status: any;

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getSPSDAttendancePeriodWeekList(schoolYear: string, periodNumber: number): Observable<ILookupBase[]> {
    return this._http.get<ILookupBase[]>(this._baseUrl + "api/SinglePageServiceDocumentation/GetSPSDAttendancePeriodWeekList?schoolYear=" + schoolYear + "&periodNumber=" + periodNumber).map((response: ILookupBase[]) => response as ILookupBase[])
      .catch(this.handleError);
  }

  getSPSDAttendancePeriodList(): Observable<ILookupBase[]> {
    return this._http.get<ILookupBase[]>(this._baseUrl + "api/SinglePageServiceDocumentation/GetSPSDAttendancePeriodList").map((response: ILookupBase[]) => response as ILookupBase[])
      .catch(this.handleError);
  }

  getSPSDStudentServicesForProviderList(): Observable<ILookupBase[]> {
    return this._http.get<ILookupBase[]>(this._baseUrl + "api/SinglePageServiceDocumentation/GetSPSDStudentServicesForProviderList").map((response: ILookupBase[]) => response as ILookupBase[])
      .catch(this.handleError);
  }

  getSPSDStudentServiceWeekList(schoolYearAttendancePeriod: string, weekNumber: string, serviceAssignmentId: string): Observable<ISPSDButtonControl[]> {
    return this._http.get<ISPSDButtonControl[]>(this._baseUrl + "api/SinglePageServiceDocumentation/GetSPSDStudentServiceWeekList?schoolYearAttendancePeriod=" + schoolYearAttendancePeriod + "&weekNumber=" + weekNumber + "&serviceAssignmentId=" + serviceAssignmentId).map((response: ISPSDButtonControl[]) => response as ISPSDButtonControl[])
      .catch(this.handleError);
  }

}
